import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VacationType } from 'src/app/shared/models/vacation';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class VacationTypeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllVacationType(): Observable<VacationType[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.vacationTypeUrl}s`,
			'getAllVacationType'
		);
	}
}
